import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const times: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M9.922-2.203a.74.74 0 0 1 .219.531q-.001.316-.22.531L8.86-.078a.74.74 0 0 1-.53.219.72.72 0 0 1-.532-.22L5.5-2.374 3.203-.078a.74.74 0 0 1-.531.219.72.72 0 0 1-.531-.22L1.078-1.14a.7.7 0 0 1-.219-.53.72.72 0 0 1 .22-.532L3.374-4.5 1.078-6.797a.7.7 0 0 1-.219-.531.72.72 0 0 1 .22-.531L2.14-8.922a.72.72 0 0 1 .53-.219q.311.001.532.22L5.5-6.626l2.297-2.297a.72.72 0 0 1 .531-.219q.31.001.531.22L9.922-7.86a.74.74 0 0 1 .219.53q-.001.317-.22.532L7.626-4.5Zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-0.86 9.14)"
    />
  ),
  svgProps: {
    height: "9.281",
    width: "9.281",
  }
};

export const timesCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.984-3.234a.5.5 0 0 0-.156-.36L7.422-5l1.406-1.422a.473.473 0 0 0 0-.703l-.703-.703a.473.473 0 0 0-.703 0L6-6.422 4.594-7.828a.5.5 0 0 0-.36-.156.5.5 0 0 0-.359.156l-.703.703a.5.5 0 0 0-.14.36q0 .204.14.343L4.594-5 3.172-3.594a.53.53 0 0 0 0 .719l.703.703q.154.14.36.14a.53.53 0 0 0 .359-.14L6-3.594l1.422 1.422q.14.14.344.14a.5.5 0 0 0 .359-.14l.703-.703a.5.5 0 0 0 .156-.36m2.204-4.782Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const timesCircleOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="m8.578-3.578-1.14 1.14a.25.25 0 0 1-.188.079.23.23 0 0 1-.172-.078L6-3.5 4.938-2.437a.25.25 0 0 1-.188.078.23.23 0 0 1-.172-.078l-1.14-1.141a.23.23 0 0 1-.079-.172q-.002-.105.079-.187L4.5-5 3.438-6.078a.23.23 0 0 1-.079-.172q-.002-.106.079-.187l1.14-1.141c.05-.05.11-.078.172-.078a.27.27 0 0 1 .188.078L6-6.5l1.078-1.078q.077-.076.172-.078a.27.27 0 0 1 .188.078l1.14 1.14a.27.27 0 0 1 .078.188.24.24 0 0 1-.078.172L7.5-5l1.078 1.063a.27.27 0 0 1 .078.187.24.24 0 0 1-.078.172m1.094.719A4.17 4.17 0 0 0 10.25-5q-.002-1.154-.578-2.125a4.1 4.1 0 0 0-1.547-1.547A4.1 4.1 0 0 0 6-9.25a4.17 4.17 0 0 0-2.14.578 4.2 4.2 0 0 0-1.547 1.547A4.17 4.17 0 0 0 1.75-5q0 1.158.563 2.14a4.3 4.3 0 0 0 1.546 1.548A4.23 4.23 0 0 0 6-.75q1.154 0 2.125-.562A4.2 4.2 0 0 0 9.672-2.86m1.516-5.157Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const timesLight: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path d="M1 1L5.5 5.23529M10 9.47059L5.5 5.23529M5.5 5.23529L10 1M5.5 5.23529L1 9.47059" strokeWidth="1.35" style={getStyle(color, pathStyle)} />
  ),
  svgProps: {
    height: "10",
    width: "11"
  },
}
